import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';
import { DrawerFormDataType } from '@/types';

import { useDeleteCNMC } from '../api/delete-cnmc';
import { usePatchCNMC } from '../api/patch-cnmc';
import { useCreateCNMC } from '../api/post-cnmc';
import { CNMC, CNMCForm } from '../types';

type TCNMCControllersReturn = {
  cnmcDialog: ReturnType<typeof useDisclosureWithData<CNMC>>;
  cnmcDrawer: ReturnType<typeof useDisclosureWithData<DrawerFormDataType<CNMC>>>;
  cnmcFilesUploadDrawer: ReturnType<typeof useDisclosureWithData<DrawerFormDataType<CNMC>>>;
  handleCNMCSubmit: (data: CNMCForm) => void;
  isMutating: boolean;
  handleDeleteCNMC: () => void;
};

export function useCNMCControllers(): TCNMCControllersReturn {
  const cnmcDialog = useDisclosureWithData<CNMC>();
  const cnmcDrawer = useDisclosureWithData<DrawerFormDataType<CNMC>>();
  const cnmcFilesUploadDrawer = useDisclosureWithData<DrawerFormDataType<CNMC>>();
  const { mutate: deleteCNMC } = useDeleteCNMC();
  const { mutate: createCNMC, isPending: isCreatingCNMC } = useCreateCNMC({
    config: {
      onSuccess: () => {
        cnmcDrawer.close();
      },
    },
  });
  const { mutate: updateCNMC, isPending: isUpdatingCNMC } = usePatchCNMC({
    config: {
      onSuccess: () => {
        cnmcDrawer.close();
      },
    },
  });
  const isMutating = isCreatingCNMC || isUpdatingCNMC;

  const handleDeleteCNMC = () => {
    if (cnmcDialog.data) {
      deleteCNMC(cnmcDialog.data.id, {
        onSuccess: () => {
          cnmcDialog.close();
        },
      });
    }
  };

  const handleCNMCSubmit = (data: CNMCForm) => {
    if (cnmcDrawer.data?.data) {
      updateCNMC({ id: cnmcDrawer.data.data.id, ...data });
      return;
    }

    createCNMC(data);
  };

  return {
    cnmcDialog,
    cnmcDrawer,
    cnmcFilesUploadDrawer,
    handleDeleteCNMC,
    handleCNMCSubmit,
    isMutating,
  };
}
